    <div class="fileUpload">
        <div class="js-element--uploadedFiles"></div>
        <div class="js-element--uploadingFiles"></div>
        <div class="fileUpload-container {{#if loading}} requestIsProcessing{{/if}}">
            <div class="fileUpload-container-cta js-element--fileUploadContainer">
                <span>Drag Files here or click to upload</span>
                <input class="fileUpload-container-cta-input js-element--fileInput" accept="image/eps,application/pdf,image/jpg,image/jpeg,image/tif,image/tiff,image/png,image/vnd.adobe.photoshop,application/postscript,application/indd,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/zip" id="fileInput" multiple type="file" placeholder="Upload File(s) here">
            </div>
            {{!-- <div class="fileUpload-container-note">Include print-ready artwork and variable data list (if applicable)</div> --}}
            <div style="padding-top: 20px; font-size: 14px; line-height: 1.5; color: var(--c-OFFBLACK)">
                For the fastest processing, please upload a
                {{#if hasPages}}
                    print-ready PDF.
                {{else}}
                    {{#if currentItem.hasVersions}}
                        {{#if currentItem.isTwoSided}}
                            single print-ready PDF with {{versionsPrintFilePages}} pages, one page for the front and back of each version.
                        {{else}}
                            single print-ready PDF with {{versionsPrintFilePages}} pages, one for each version.
                        {{/if}}
                    {{else}}
                        {{#if currentItem.isTwoSided}}
                            single print-ready PDF with 2 pages, one for the front and one for the back.
                        {{else}}
                            print-ready PDF.
                        {{/if}}
                    {{/if}}
                {{/if}}
                <style>
                    .pdfIcon:before {
                        display: inline-block;
                        content: "\f1c1";
                        font-family: var(--f-ICONS);
                        font-size: 14px;
                    }
                </style>
                <span class="pdfIcon"></span>
                <div>
                    <a style="color: var(--c-BRAND)" href="/support/file-preparation" target="_blank">Help</a>
                </div>
            </div>
        </div>
        {{#if currentItem.hasVariableData}}
        <div class="fileUpload-container" style="margin-top: 20px;">
            <h4 style="margin: 0 0 10px; font-size: 18px; font-weight: normal;">Data File Upload</h4>
            <div class="fileUpload-container-cta js-element--fileUploadContainer">
                <span>Drag your recipient list here or click to upload (.csv, .xlsx, .xls, .txt)</span>
                <input class="fileUpload-container-cta-input js-element--fileInput" accept=".csv,.xlsx,.xls,.txt,text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,text/plain" id="dataFileInput" multiple type="file" placeholder="Upload data file here">
            </div>
            <div style="padding-top: 10px; font-size: 14px; line-height: 1.5; color: var(--c-OFFBLACK)">
                Your recipient list is used for variable data addressing{{#if currentItem.companionItemNames.length}} and will be attached to your matching envelope job automatically{{/if}}.
            </div>
        </div>
        {{/if}}
    </div>
    <div class="globalDialog-ft globalDialog-ft_alignRight">
        <button class="btn btn_right js-action--close {{#if loading}} requestIsProcessing{{/if}}">Done</button>
    </div>
